<main>
  <div class="as-row as-justify-end">
    <mat-icon
      svgIcon="ic-close-green"
      class="as-pointer"
      mat-dialog-close
    ></mat-icon>
  </div>

  <div class="as-row as-gap-10 info">
    <div class="icon-wrapper">
      <mat-icon
        [svgIcon]="
          data.type === 'warn' ? 'ic-warning-alert' : 'ic-green-checkmark'
        "
      ></mat-icon>
    </div>
    <div class="as-column as-gap-10">
      <p class="as-font as-font-20 as-font-w-700 as-font-black-gray">
        {{ data.title }}
      </p>
      <p class="as-font as-font-16 as-font-normal as-font-black-gray">
        {{ data.subtitle }}
      </p>
    </div>
  </div>

  @if (data.seeMyPoints) {
    <div
      class="as-row as-align-center as-justify-sb as-buttons-container"
      >
      <button
        (click)="openRedeemModal()"
        class="as-font-green"
        mat-stroked-button
        color="accent"
        >
        {{ 'CLUB.seeMyPoints' | translate }}
      </button>
      <button
        mat-dialog-close
        class="as-color-white as-understood"
        mat-flat-button
        color="accent"
        >
        {{ 'CLUB.understood' | translate }}
      </button>
    </div>
  } @else {
    <div class="as-buttons-container">
      <button
        mat-dialog-close
        class="as-full as-color-white"
        mat-flat-button
        color="accent"
        >
        {{ 'CLUB.understood' | translate }}
      </button>
    </div>
  }
  <ng-template #understood>
    <div class="as-buttons-container">
      <button
        mat-dialog-close
        class="as-full as-color-white"
        mat-flat-button
        color="accent"
        >
        {{ 'CLUB.understood' | translate }}
      </button>
    </div>
  </ng-template>
</main>
